import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { tenantService } from '@/services/tenantService';
import { useRavanStore } from '@/stores/ravanStore';

export function GlobalRavanFAB() {
  const location = useLocation();
  const { toggleRavan, isOpen } = useRavanStore();
  const [isPro, setIsPro] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    tenantService.getCurrentTenant().then((tenant) => {
      if (tenant?.plan === 'pro' || tenant?.plan === 'enterprise') {
        setIsPro(true);
        // Delay visibility slightly for a smooth entrance
        setTimeout(() => setIsVisible(true), 1000);
      }
    });
  }, []);

  // Don't show if not Pro, or if the overlay is already open
  if (!isPro || isOpen) {
    return null;
  }

  return (
    <button
      onClick={toggleRavan}
      className={cn(
        'fixed bottom-6 right-6 z-40 h-14 w-14 rounded-2xl shadow-2xl shadow-emerald-500/20 flex items-center justify-center transition-all duration-500 hover:scale-105 active:scale-95 group overflow-hidden border border-emerald-500/20 bg-slate-900',
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
      )}
      aria-label="Open Ravan AI"
    >
      <div className="absolute inset-0 bg-emerald-500/10 group-hover:bg-emerald-500/20 transition-colors" />
      <img 
        src="/images/avatars/ravan_base.png" 
        alt="RAVAN AI" 
        className="h-full w-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
      />
      {/* Pulse indicator */}
      <span className="absolute -top-1 -right-1 h-3.5 w-3.5 rounded-full bg-emerald-400 border-2 border-slate-900 animate-pulse shadow-[0_0_10px_rgba(52,211,153,0.5)]" />
    </button>
  );
}
